export default (url, state = null, title = '') => {
  // eslint-disable-next-line no-restricted-globals
  history.replaceState(state, title, url);
};
